"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeSubscriptionPlanLoadingSelector = exports.toggleActiveLoadingSelector = exports.myAnnouncementsSelector = exports.myAnnouncementsLoadingSelector = exports.upgradePostSubscription = exports.updateToTop = exports.deActivatePost = exports.activatePost = exports.removeMyAnnouncement = exports.getMyAnnouncements = exports.changeSubscriptionPlan = exports.changeSubscriptionPlanFailure = exports.changeSubscriptionPlanSuccess = exports.changeActivationStatusSuccess = exports.changeActivationStatusFailure = exports.changingActivationStatus = exports.removeMyAnnouncementFailure = exports.removingMyAnnouncement = exports.fetchingMyAnnouncementsFailure = exports.fetchingMyAnnouncementsSuccess = exports.fetchingMyAnnouncements = exports.myAnnouncementsSlice = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var axios_1 = __importDefault(require("axios"));
var subscriptionSlice_1 = require("../subscription/subscriptionSlice");
var GeneralSettings_1 = require("../../constants/GeneralSettings");
var initialState = {
    loading: false,
    data: null,
};
exports.myAnnouncementsSlice = toolkit_1.createSlice({
    name: 'myAnnouncements',
    initialState: initialState,
    reducers: {
        fetchingMyAnnouncements: function (state) {
            state.loading = true;
        },
        fetchingMyAnnouncementsSuccess: function (state, action) {
            state.loading = false;
            state.data = action.payload;
        },
        fetchingMyAnnouncementsFailure: function (state) {
            state.loading = false;
        },
        removingMyAnnouncement: function (state) {
            state.loading = true;
        },
        removeMyAnnouncementFailure: function (state) {
            state.loading = false;
        },
        changingActivationStatus: function (state) {
            state.loading = true;
        },
        changeActivationStatusSuccess: function (state, action) {
            state.loading = false;
            if (state.data) {
                state.data.data = state.data.data.map(function (item) {
                    return item.id === action.payload.id
                        ? __assign(__assign({}, item), { active: action.payload.active, period: action.payload.period }) : item;
                });
            }
        },
        changeActivationStatusFailure: function (state) {
            state.loading = false;
        },
        changeSubscriptionPlan: function (state) {
            state.loading = true;
        },
        changeSubscriptionPlanSuccess: function (state, premium) {
            state.loading = false;
            if (state.data) {
                state.data.data = state.data.data.map(function (item) {
                    return item.id === premium.payload.postId
                        ? __assign(__assign({}, item), { subscriptionPlan: GeneralSettings_1.GENERAL_SETTINGS.PLANS.PREMIUM }) : item;
                });
            }
        },
        changeSubscriptionPlanFailure: function (state) {
            state.loading = false;
        },
    },
});
exports.fetchingMyAnnouncements = (_a = exports.myAnnouncementsSlice.actions, _a.fetchingMyAnnouncements), exports.fetchingMyAnnouncementsSuccess = _a.fetchingMyAnnouncementsSuccess, exports.fetchingMyAnnouncementsFailure = _a.fetchingMyAnnouncementsFailure, exports.removingMyAnnouncement = _a.removingMyAnnouncement, exports.removeMyAnnouncementFailure = _a.removeMyAnnouncementFailure, exports.changingActivationStatus = _a.changingActivationStatus, exports.changeActivationStatusFailure = _a.changeActivationStatusFailure, exports.changeActivationStatusSuccess = _a.changeActivationStatusSuccess, exports.changeSubscriptionPlanSuccess = _a.changeSubscriptionPlanSuccess, exports.changeSubscriptionPlanFailure = _a.changeSubscriptionPlanFailure, exports.changeSubscriptionPlan = _a.changeSubscriptionPlan;
var getMyAnnouncements = function (page) {
    if (page === void 0) { page = 1; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.fetchingMyAnnouncements());
                    return [4 /*yield*/, axios_1.default.get("/api/post?page=" + page)];
                case 1:
                    data = (_a.sent()).data;
                    dispatch(exports.fetchingMyAnnouncementsSuccess(data));
                    return [2 /*return*/, data];
                case 2:
                    e_1 = _a.sent();
                    dispatch(exports.fetchingMyAnnouncementsFailure());
                    throw e_1;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getMyAnnouncements = getMyAnnouncements;
var removeMyAnnouncement = function (id) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch(exports.removingMyAnnouncement());
                    return [4 /*yield*/, axios_1.default.delete("/api/post/" + id)];
                case 1:
                    data = (_a.sent()).data;
                    return [4 /*yield*/, dispatch(exports.getMyAnnouncements())];
                case 2:
                    _a.sent();
                    return [2 /*return*/, data];
                case 3:
                    e_2 = _a.sent();
                    dispatch(exports.removeMyAnnouncementFailure());
                    throw e_2;
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.removeMyAnnouncement = removeMyAnnouncement;
var activatePost = function (id) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.changingActivationStatus());
                    return [4 /*yield*/, axios_1.default.put("/api/post/" + id + "/activate")];
                case 1:
                    _a.sent();
                    dispatch(exports.changeActivationStatusSuccess({
                        id: id,
                        active: true,
                        period: null,
                    }));
                    return [3 /*break*/, 3];
                case 2:
                    e_3 = _a.sent();
                    dispatch(exports.changeActivationStatusFailure());
                    throw e_3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.activatePost = activatePost;
var deActivatePost = function (id, period) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.changingActivationStatus());
                    return [4 /*yield*/, axios_1.default.put("/api/post/" + id + "/deactivate", {
                            period: period,
                        })];
                case 1:
                    _a.sent();
                    dispatch(exports.changeActivationStatusSuccess({
                        id: id,
                        active: false,
                        period: period,
                    }));
                    return [3 /*break*/, 3];
                case 2:
                    e_4 = _a.sent();
                    dispatch(exports.changeActivationStatusFailure());
                    throw e_4;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.deActivatePost = deActivatePost;
var updateToTop = function (id, isFavorite) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var e_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.fetchingMyAnnouncements());
                    return [4 /*yield*/, axios_1.default.post("/api/post/" + id + "/update-to-top?is_favorite=" + isFavorite)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_5 = _a.sent();
                    dispatch(exports.fetchingMyAnnouncementsFailure());
                    throw e_5;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.updateToTop = updateToTop;
var upgradePostSubscription = function (planId, postId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var e_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(exports.changeSubscriptionPlan());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, axios_1.default.post("/api/subscriptions/" + planId + "/posts/" + postId)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, dispatch(subscriptionSlice_1.subscribeSuccess())];
                case 3:
                    _a.sent();
                    dispatch(exports.changeSubscriptionPlanSuccess({
                        postId: postId,
                    }));
                    return [3 /*break*/, 5];
                case 4:
                    e_6 = _a.sent();
                    dispatch(exports.changeSubscriptionPlanFailure());
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
exports.upgradePostSubscription = upgradePostSubscription;
var myAnnouncementsLoadingSelector = function (state) {
    return state.myAnnouncements.loading;
};
exports.myAnnouncementsLoadingSelector = myAnnouncementsLoadingSelector;
var myAnnouncementsSelector = function (state) {
    return state.myAnnouncements.data;
};
exports.myAnnouncementsSelector = myAnnouncementsSelector;
var toggleActiveLoadingSelector = function (state) {
    return state.myAnnouncements.loading;
};
exports.toggleActiveLoadingSelector = toggleActiveLoadingSelector;
var changeSubscriptionPlanLoadingSelector = function (state) {
    return state.myAnnouncements.loading;
};
exports.changeSubscriptionPlanLoadingSelector = changeSubscriptionPlanLoadingSelector;
exports.default = exports.myAnnouncementsSlice.reducer;
